export default "__VITE_ASSET__e8a750d5__"